// src/components/layout/Footer.jsx
    import { FaFacebook, FaInstagram } from "react-icons/fa";

import React from "react";

function Footer() {
  return (
    <footer className="main-footer">
      <p>© 2026 Flexotec Maria — جميع الحقوق محفوظة</p>
  
<div className="social-icons">
  <a href="https://facebook.com" target="_blank"><FaFacebook /></a>
  <a href="https://instagram.com" target="_blank"><FaInstagram /></a>
</div>
  </footer>

  );
}

export default Footer;
